// Generated by CoffeeScript 1.12.7

/**
Get a single parameter from the query string

@method getQueryStringParameter
@param name name of query string
@param url (optional) url to parse. if not url is pass then uses location
@return {String}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/get_query_string_parameter',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.getQueryStringParameter = factory();
  }
})(this, function() {
  var getQueryStringParameter;
  return getQueryStringParameter = function(name, url) {
    var regex, results;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    regex = new RegExp("[\\\\?&]" + name + "=([^&#]*)");
    results = regex.exec(url || location.search);
    if (results === null) {
      return "";
    } else {
      return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  };
});

